var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiagnosticIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6361 1.66699H4.9694C4.52737 1.66699 4.10345 1.84259 3.79089 2.15515C3.47833 2.46771 3.30273 2.89163 3.30273 3.33366V16.667C3.30273 17.109 3.47833 17.5329 3.79089 17.8455C4.10345 18.1581 4.52737 18.3337 4.9694 18.3337H14.9694C15.4114 18.3337 15.8354 18.1581 16.1479 17.8455C16.4605 17.5329 16.6361 17.109 16.6361 16.667V6.66699L11.6361 1.66699Z",
    stroke: "#D4D4D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9043 10.2296L9.9043 14.9043",
    stroke: "#D4D4D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87891 8.58008L6.87891 14.9046",
    stroke: "#D4D4D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9277 14.9045L12.9277 13.6671L12.9277 12.4297",
    stroke: "#D4D4D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6699 1.66699V6.66699H16.6699",
    stroke: "#D4D4D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagnosticIcon);
export default __webpack_public_path__ + "static/media/diagnostic-icon.86634d0a5d4c032dee03a9a35d4b3b8b.svg";
export { ForwardRef as ReactComponent };